import { snapValue } from '~/lib/snap';
import { useStore } from '~/store';

const SNAP_RADIUS_STAGE_PX = 6;

/** Snap a 1D value to vertical (x) or horizontal (y) guidelines. */
export function snapAxis(value: number, axis: 'x' | 'y'): number {
  const { editor } = useStore.getState();
  if (!editor.snapToGuidelines) return value;
  const targets = axis === 'x' ? editor.guidelines.vertical : editor.guidelines.horizontal;
  if (targets.length === 0) return value;
  return snapValue(value, targets, SNAP_RADIUS_STAGE_PX, editor.stageScale);
}

/**
 * Best snap delta when multiple candidate positions of a moving shape
 * (e.g., bbox left/center/right) could snap to a guideline. Returns 0
 * when no candidate is within the screen-space radius.
 */
export function snapAxisDelta(values: readonly number[], axis: 'x' | 'y'): number {
  const { editor } = useStore.getState();
  if (!editor.snapToGuidelines) return 0;
  const targets = axis === 'x' ? editor.guidelines.vertical : editor.guidelines.horizontal;
  if (targets.length === 0) return 0;
  const radiusSrc = SNAP_RADIUS_STAGE_PX / editor.stageScale;
  let bestDelta = 0;
  let bestDist = radiusSrc;
  for (const v of values) {
    for (const t of targets) {
      const d = Math.abs(v - t);
      if (d < bestDist) {
        bestDist = d;
        bestDelta = t - v;
      }
    }
  }
  return bestDelta;
}
